import React from 'react';

const GreyDot = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9" cy="9" r="9" fill="#F2F2F2" />
    <circle cx="9" cy="9" r="4" fill="#A6A7B0" />
  </svg>
);

export default GreyDot;
